// eslint-disable-next-line @typescript-eslint/no-var-requires
const { LOGIN_TYPE } = require('@/constants/data')

module.exports = {
  SERVICE_NAME: 'webs',
  MAIN_COLOR: '#26a0f6',

  /** 한국어 여부 (한국어/영어)  */
  KOREAN: true,

  /** 로그인 설정 */
  LOGIN: {
    /** 로그인 사용여부 */
    enabled: false,
    /** 로그인 타입 사용여부 */
    allowTypes: [
      // LOGIN_TYPE.DEFAULT, // 기본(로그인아이디 or 이메일)
      // LOGIN_TYPE.GOOGLE,
      // LOGIN_TYPE.NAVER,
      // LOGIN_TYPE.KAKAO,
      // LOGIN_TYPE.APPLE,
    ],
    /** 기본 로그인 아이디 사용여부(로그인아이디 or 이메일) */
    useId: false,
    /** 이메일 인증 사용 여부 */
    useCheckEmail: false,

    TEXT: {
      /** LoginPage */
      btn_find_password: '비밀번호 찾기',
      btn_default_signup: '회원가입',

      /** LoginForm */
      loginId: {
        placeholder: '아이디',
        error: '아이디를 입력해주세요.',
      },
      email: {
        placeholder: '이메일',
        error: '이메일을 입력해주세요.',
      },
      password: {
        placeholder: '비밀번호',
        error: '비밀번호를 입력해주세요.',
      },
      btn_login: '로그인',
      btn_social_login: '',
    },
  },

  /**
   * 로고 설정
   */
  LOGO: {
    /** 기본로고 사이즈 */
    DEFAULT: { src: '/assets/logos/default_logo.svg', width: 154, height: 30 },
    /** 대비로고 사이즈 */
    FOREGROUND: { src: '/assets/logos/foreground_logo.svg', width: 154, height: 30 },
  },

  /** 푸터 설정 */
  FOOTER: {
    isDark: false,
    alignCenter: false,

    contents: [
      ['라임프렌즈 | 대표 : 정영찬 | 사업자 등록번호 :  529-87-00609'],
      ['본사 : 충청남도 청양군 청양읍 칠갑산로1길 31, 3층 317호(충남사회적경제혁신타운)'],
      ['연구소 : 서울 금천구 가산디지털1로 16 SK V1 AP타워 611호'],
    ],
    contact: 'lime@limefriends.com',
    tel: '0505-901-0608',
    copyright: `© ${new Date().getFullYear()} 라임프렌즈`,
  },

  /** 메인 팝업 */
  MAIN_POPUP: {
    /** 사용 여부 */
    enabled: true,

    /** 팝업 슬라이드 기본 노출 갯수 1 or 2개*/
    showOnly1: true,

    TEXT: {
      linkText: '자세히 보기',
      doNotShowToday: '오늘 하루 보지 않기',
      closeBtn: '닫기',
    },
  },

  /** 공통 컴포넌트 문구 관리 */
  TEXT: {
    /** NaviActions */
    menu_login: '로그인',
    btn_logout: '로그아웃',
    btn_mypage: '마이페이지',

    /** ShareButton */
    btn_share: '공유하기',

    /** BasicModal */
    modal: {
      btn_confirm: '확인',
      btn_cancel: '취소',
    },
  },
}
